<div class="uav-data-panel">
  <div class="map-wrapper">
    <div class="map-container">
      <div class="map-instance">
        <app-openstreetmap
          [mapOptions]="osmMapOptions"
          [mapController$]="osmMapController"
          (mapReady)="onMapReady()"
        ></app-openstreetmap>
      </div>
    </div>
  </div>
  <div class="data-content">
    <div class="content-header">
      <div class="header-title">
        <app-back-button [title]="'UAV Data'" [parentRoute]="'/'">
        </app-back-button>
      </div>
      <div class="header-actions">
        <app-primary-button
          title="Upload"
          icon="pi pi-plus"
          (action)="openUploadModal()"
        ></app-primary-button>
      </div>
    </div>

    <div class="card-grid">
      @for (survey of surveys; track survey.id) {
      <div class="data-card" (click)="onCardClick(survey)" [class.active]="selectedSurveyId === survey.id">
        <div class="card-image">
          <img [src]="(survey.representativePhoto && survey.representativePhoto.hasPhoto)
             ? getImageUrl(survey.representativePhoto.previewFileStorageId)
             : 'assets/images/uav-placeholder.png'" (error)="onImageError($event)" [alt]="'UAV Data' | translate">
          <div class="card-image-actions">
            <button class="btn btn-icon btn-gallery" (click)="openGalleryModal(survey); $event.stopPropagation()"
              [attr.aria-label]="'Gallery' | translate">
              <img src="assets/icons/main/light/gallery.svg" alt="Gallery"> <span class="icon-gallery"></span>
            </button>
            <button class="btn btn-icon btn-info" (click)="openEditModal(survey); $event.stopPropagation()"
              [attr.aria-label]="'Info' | translate">
              <img src="assets/icons/main/light/edit-2-fill.svg">
              <span class="icon-info"></span>
            </button>
            <button (click)="onDeleteSurvey(survey); $event.stopPropagation()" class="btn btn-icon btn-delete"
              [attr.aria-label]="'Delete' | translate">
              <img src="assets/icons/main/light/delete-icon.svg">
              <span class="icon-delete"></span>
            </button>
          </div>
        </div>
        <div class="card-body">
          @if (survey.name) {
            <div class="info-item">
              <span [attr.title]="survey.name">{{ survey.name }}</span>
            </div>
          }
          <div class="info-item">
            <app-region-display
              [regionId]="survey.representativePhoto?.regionId"
              [showDistrict]="false"
              cssClass="info-item"
            />
          </div>
          <div class="info-item">
            <app-region-display
              [regionId]="survey.representativePhoto?.regionId"
              [showRegion]="false"
              cssClass="info-item"
            />
          </div>
          <div class="info-row">
            <div class="info-item">
              <span>
                {{ (survey.representativePhoto?.originalDate
                ? (survey.representativePhoto?.originalDate | date: 'dd.MM.yyyy') : ('No date' | translate))
                }}
              </span>
              <label>{{ 'Image Date' | translate }}</label>
            </div>
            <div class="info-item">
              <span>{{ survey.createAt | date: 'dd.MM.yyyy' }}</span>
              <label>{{ 'Upload Date' | translate }}</label>
            </div>
            <div class="info-item">
              <span>{{ survey.sourceType | uavSourceTypeLabel | translate }}</span>
              <label>{{ 'Data source' | translate }}</label>
            </div>
          </div>
          <div class="card-tags">
            <span class="tag-text" [title]="survey.tagNames ? ('Tags' | translate) + ': ' + survey.tagNames : ''">
              {{ 'Tags' | translate }}:
              @if (survey.tagNames) {
              {{ survey.tagNames }}
              } @else {
              ({{ 'No data' | translate }})
              }
            </span>
          </div>
          <p class="card-description">
            {{ survey.comment }}
          </p>
        </div>
      </div>
      } @empty {
      @if (!isLoading) {
      <div class="data-placeholder">
        @if (loadFailed) {
        <p>{{ 'UAV_DATA_LOAD_FAILED' | translate }}</p>
        } @else {
        <p>{{ 'UAV_DATA_NO_RESULTS' | translate }}</p>
        }
      </div>
      }
      }
    </div>

    @if (isLoading) {
    <div class="loading-indicator">
      <p>{{ 'Loading...' | translate }}</p>
    </div>
    }

    <div class="pagination-controls">
      <span class="pagination-info">{{ 'Total' | translate }}: {{ totalCount }}</span>
      <div class="pagination">
        <button class="btn btn-icon" (click)="goToFirstPage()" [disabled]="currentPage === 1 || isLoading"
          [title]="'First page' | translate">
          &laquo;
        </button>
        <button class="btn btn-icon" (click)="prevPage()" [disabled]="currentPage === 1 || isLoading"
          [title]="'Previous page' | translate">
          &lt;
        </button>
        @for (page of visiblePages; track $index) {
        @if (page === '...') {
        <span class="pagination-dots">...</span>
        } @else {
        <button class="btn-page" [class.active]="currentPage === page" (click)="goToPage($any(page))"
          [disabled]="isLoading">
          {{ page }}
        </button>
        }
        }
        <button class="btn btn-icon" (click)="nextPage()" [disabled]="currentPage === totalPages || isLoading"
          [title]="'Next page' | translate">
          &gt;
        </button>
        <button class="btn btn-icon" (click)="goToLastPage()" [disabled]="currentPage === totalPages || isLoading"
          [title]="'Last page' | translate">
          &raquo;
        </button>
      </div>
    </div>
  </div>

  <div class="data-filters">
    <div class="filter-header">
      <h3>{{ 'Filters' | translate }}</h3>
      <span class="icon-filter-list"></span>
    </div>
    <form class="filter-form" (ngSubmit)="applyFilters()">

      <div class="form-group">
        <label>{{ 'Name' | translate }}</label>
        <msf-input
          [(model)]="filters.name"
          [placeholder]="'Name' | translate"
        />
      </div>

      <div class="form-group">
        <label> {{ 'Region' | translate }} </label>
        <msf-tree-select
          [(model)]="filters.regionId"
          [service]="regionManagerService"
          serviceMethod="getRegionsObservable"
          [placeholder]="'Select Region' | translate"
          [showClear]="true"
          [treeBy]="'parentId'"
          (modelChange)="onRegionSelected(filters.regionId)"
        />
      </div>

      <div class="form-group">
        <app-generic-selector [config]="fieldSelectorConfig" [(ngModel)]="filters.fieldId" name="fieldId"
                              [label]="'Fields' | translate" [placeholder]="'Select field' | translate">
        </app-generic-selector>
      </div>

      <div class="form-group">
        <label>{{ 'Period' | translate }}</label>
        <div class="date-range-group">

          <app-date-picker [(ngModel)]="filters.startDate" name="startDate" [placeholder]="'Start' | translate"
            [showIcon]="true" [showClear]="true">
          </app-date-picker>

          <span class="date-separator">-</span>

          <app-date-picker [(ngModel)]="filters.endDate" name="endDate" [placeholder]="'End' | translate"
            [showIcon]="true" [showClear]="true">
          </app-date-picker>

        </div>
      </div>

      <div class="form-group">
        <label for="filter-data-type">{{ 'Data type' | translate }}</label>
        <select id="filter-data-type" class="form-control" [(ngModel)]="filters.dataType" name="dataType">
          <option [ngValue]="null" selected>{{ 'All' | translate }}</option>
          @for (type of uavDataTypes; track type.id) {
          <option [value]="type.id">{{ type | serverTranslate:'names' }}</option>
          }
        </select>
      </div>

      <div class="form-group">
        <label>{{ 'Data source' | translate }}</label>
        <msf-select
          [(model)]="filters.sourceType"
          [options]="sourceTypeOptions"
          [translateBy]="'locale'"
          [showClear]="true"
          [placeholder]="'All' | translate"
        />
      </div>

      <div class="form-group">
        <app-generic-selector [config]="cropSelectorConfig" [(ngModel)]="filters.cropId" name="cropId"
          [label]="'Culture' | translate" [placeholder]="'Select culture' | translate" [pageSize]="100">
        </app-generic-selector>
      </div>

      <div class="form-group">
        <app-generic-selector [config]="firmSelectorConfig" [(ngModel)]="filters.firmId" name="firmId"
          [label]="'Agricultural producers' | translate" [placeholder]="'Select producer' | translate">
        </app-generic-selector>
      </div>

      <div class="form-group">
        <app-generic-selector [config]="tagSelectorConfig" [(ngModel)]="filters.tagId" name="tagId"
          [label]="'Tags' | translate" [placeholder]="'Select tags' | translate">
        </app-generic-selector>
      </div>

      <div class="form-actions">
        <app-primary-button
          width="100%"
          title="Apply"
          (action)="applyFilters()"
        ></app-primary-button>
        <app-secondary-button
          title="Reset filter"
          width="100%"
          (action)="resetFilters()"
        ></app-secondary-button>
      </div>
    </form>
  </div>
</div>

<app-uav-upload-modal
  [isVisible]="isUploadModalVisible"
  (close)="closeUploadModal()"
  (uploadSuccess)="onUploadSuccess()"
></app-uav-upload-modal>

<app-uav-edit-modal
  [isVisible]="isEditModalVisible"
  [survey]="selectedSurvey" (close)="closeEditModal()"
  (updateSuccess)="onUpdateSuccess()"
></app-uav-edit-modal>

<app-confirmation-modal
  [isVisible]="isDeleteConfirmVisible" [title]="'Delete Survey' | translate"
  [message]="'Are you sure you want to delete this item?' | translate"
  [confirmText]="'Delete' | translate"
  [cancelText]="'Cancel' | translate" (confirm)="onConfirmDelete()"
  (cancel)="closeDeleteConfirm()">
</app-confirmation-modal>

<app-uav-gallery-modal
  [isVisible]="isGalleryModalVisible"
  [survey]="selectedGallerySurvey"
  (close)="closeGalleryModal()"
></app-uav-gallery-modal>
